import { createSlice } from '@reduxjs/toolkit';

// `update` is a load from the server (preferences/get): it also sets `loaded`, a marker with its
// own sequence number, so a page can tell a load from a save's acknowledgement. `saved` is the
// user's own save, applied at once. `loadFailed` is a load that got no answer: it sets `loaded`
// with no currency, so a page waiting for the load goes on with the default.
// `requests` is what is in flight (ANS-1118): `loading` while a load is outstanding, `saving`
// the number of saves not yet acknowledged, `saveFailed` once a save got no answer. Neither
// `loaded` nor `requests` is sent to the server.
export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {},
  reducers: {
    loading: (state) => ({
      ...state,
      requests: { ...state.requests, loading: true },
    }),
    update: (state, action) => ({
      ...state,
      ...action.payload,
      loaded: {
        seq: ((state.loaded && state.loaded.seq) || 0) + 1,
        currency: (action.payload || {}).currency,
      },
      requests: { ...state.requests, loading: false },
    }),
    loadFailed: (state) => ({
      ...state,
      loaded: {
        seq: ((state.loaded && state.loaded.seq) || 0) + 1,
        currency: undefined,
        failed: true,
      },
      requests: { ...state.requests, loading: false },
    }),
    saved: (state, action) => ({
      ...state,
      ...action.payload,
      requests: {
        ...state.requests,
        saving: ((state.requests && state.requests.saving) || 0) + 1,
        saveFailed: false,
      },
    }),
    saveSettled: (state, action) => ({
      ...state,
      requests: {
        ...state.requests,
        saving: state.requests.saving - 1,
        saveFailed: Boolean(action.payload && action.payload.failed),
      },
    }),
  },
});

export default preferencesSlice.reducer;
